import React from 'react';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export const Contact = () => {
  return <section id="contact" className="py-20 px-6 md:px-12 bg-black bg-opacity-70" data-id="element-32">
      <div className="max-w-6xl mx-auto" data-id="element-33">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center" data-id="element-34">
          Get In Touch
        </h2>
        <div className="grid md:grid-cols-2 gap-12" data-id="element-35">
          <div data-id="element-36">
            <h3 className="text-2xl font-bold text-white mb-6" data-id="element-37">
              Contact Information
            </h3>
            <div className="space-y-6" data-id="element-38">
              <div className="flex items-center" data-id="element-39">
                <MailIcon className="text-purple-400 mr-4" size={24} data-id="element-40" />
                <div data-id="element-41">
                  <p className="text-gray-400" data-id="element-42">Email</p>
                  <a href="mailto:maila.akbar@example.com" className="text-white hover:text-purple-300" data-id="element-43">
                    maila.akbar@example.com
                  </a>
                </div>
              </div>
              <div className="flex items-center" data-id="element-44">
                <PhoneIcon className="text-purple-400 mr-4" size={24} data-id="element-45" />
                <div data-id="element-46">
                  <p className="text-gray-400" data-id="element-47">Phone</p>
                  <a href="tel:+1234567890" className="text-white hover:text-purple-300" data-id="element-48">
                    +123 456 7890
                  </a>
                </div>
              </div>
              <div className="flex items-center" data-id="element-49">
                <MapPinIcon className="text-purple-400 mr-4" size={24} data-id="element-50" />
                <div data-id="element-51">
                  <p className="text-gray-400" data-id="element-52">Location</p>
                  <p className="text-white" data-id="element-53">Your City, Country</p>
                </div>
              </div>
            </div>
          </div>
          <div data-id="element-54">
            <form className="space-y-4" data-id="element-55">
              <div data-id="element-56">
                <label htmlFor="name" className="block text-white mb-2" data-id="element-57">
                  Name
                </label>
                <input type="text" id="name" className="w-full bg-gray-800 text-white border border-gray-700 rounded-lg px-4 py-2 focus:outline-none focus:border-purple-500" placeholder="Your Name" data-id="element-58" />
              </div>
              <div data-id="element-59">
                <label htmlFor="email" className="block text-white mb-2" data-id="element-60">
                  Email
                </label>
                <input type="email" id="email" className="w-full bg-gray-800 text-white border border-gray-700 rounded-lg px-4 py-2 focus:outline-none focus:border-purple-500" placeholder="your.email@example.com" data-id="element-61" />
              </div>
              <div data-id="element-62">
                <label htmlFor="message" className="block text-white mb-2" data-id="element-63">
                  Message
                </label>
                <textarea id="message" rows={5} className="w-full bg-gray-800 text-white border border-gray-700 rounded-lg px-4 py-2 focus:outline-none focus:border-purple-500" placeholder="Your message here..." data-id="element-64" />
              </div>
              <button type="submit" className="px-8 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors" data-id="element-65">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
};